import { Grid } from '@mui/material'
import { keepPreviousData, useMutation, useQuery } from '@tanstack/react-query'
import { PaginationState } from '@tanstack/table-core'
import { productApis } from 'api'
import { PRODUCTS } from 'constans/queryKeys'
import { useState } from 'react'
import { Container } from 'shared/components'
import { AllowChangeTemProductModel, ProductRequestModel } from 'types/products'
import ProductFilter from './filters'
import ProductList from './list'
import ProductSelectDialog from './select-product-dialog'
import useToastify from 'hooks/useToastify'

const Products = () => {
  const { showError, showSuccess } = useToastify()
  const [openDialog, setOpenDialog] = useState(false)
  const [filterParams, setFilterParams] = useState<ProductRequestModel>({
    allowChangeTem: -1,
    pageIndex: 0,
    pageSize: 10,
  })
  const { data } = useQuery({
    queryKey: [PRODUCTS, ...[filterParams]],
    queryFn: () =>
      productApis.getList({
        ...filterParams,
      }),
    placeholderData: keepPreviousData,
  })

  const { mutate, isPending } = useMutation({
    mutationFn: (payload: AllowChangeTemProductModel) =>
      productApis.updateAllowTemChange(payload),
  })

  const { mutate: syncData, isPending: isSyncData } = useMutation({
    mutationFn: () => productApis.syncData(),
    onError: () => {
      showError('Đã xảy ra lỗi, vui lòng thử lại!')
    },
    onSuccess: () => {
      showSuccess('Đồng bộ dữ liệu thành công!')
    },
  })

  const handleFilterChange = (f: ProductRequestModel) => {
    setFilterParams(f)
  }

  const handlePageChange = (state: PaginationState) => {
    setFilterParams({
      ...filterParams,
      ...state,
    })
  }

  const handleButtonClick = () => {
    setOpenDialog(true)
  }

  const onCloseDialog = () => {
    setOpenDialog(false)
  }

  const handleSyncData = () => {
    syncData()
  }

  return (
    <Container title="Quản lí sản phẩm">
      <Grid flexDirection="column" container>
        <Grid item>
          <ProductFilter
            filter={filterParams}
            onFilterChange={handleFilterChange}
            onButtonClick={handleButtonClick}
            onSyncData={handleSyncData}
            isSyncData={isSyncData}
          />
        </Grid>
        <Grid item>
          <ProductList
            pageIndex={filterParams.pageIndex || 0}
            pageSize={filterParams.pageSize || 0}
            data={data?.Result || []}
            onPageChange={handlePageChange}
            mutate={mutate}
            isPending={isPending}
          />
        </Grid>
      </Grid>
      <ProductSelectDialog
        mutate={mutate}
        open={openDialog}
        onClose={onCloseDialog}
        isPending={isPending}
      />
    </Container>
  )
}

export default Products
